import { UserCheck, Clock, Calendar, UserX } from 'lucide-react';

export const DAY_NAMES = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

export const TIME_SLOTS = ["08:00", "09:00", "10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"];

export const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const DAY_NAMES_SHORT = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

export const STATUS_CONFIG = {
  activo: { label: 'Activo', color: 'bg-green-500/20 text-green-300', icon: UserCheck },
  pasivo: { label: 'Pasivo', color: 'bg-yellow-500/20 text-yellow-300', icon: Clock },
  eventual: { label: 'Eventual', color: 'bg-blue-500/20 text-blue-300', icon: Calendar },
  eliminado: { label: 'Eliminado', color: 'bg-red-500/20 text-red-300', icon: UserX }
};

export const getWhatsAppLink = (number, userName) => {
  if (!number) return null;
  const cleanNumber = number.replace(/\D/g, '');
  const message = encodeURIComponent(`Hola ${userName}, te escribimos desde City Virtual Golf.`);
  return `https://wa.me/${cleanNumber}?text=${message}`;
};

export const formatPhoneDisplay = (number) => {
  if (!number) return 'No registrado';
  return number;
};
